export const distinctIdCookieKey = 'distinct_id'
